import { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getUserEmailSelector, makeSelectAppLoggedIn } from "../app/appSelectors.js";
import { useMobileFirebaseProviderContext } from "../mobileAppCore/providers/MobileFirebaseProvider/MobileFirebaseProviderContext";

function ExponeaProvider(props) {
    const {firebaseToken} = useMobileFirebaseProviderContext();
    const {email, isLoggedIn} = props;

    useEffect(() => {
        if (email && isLoggedIn) {
            const customerIdentifier = {registered: email};
            const properties = {};
            if (firebaseToken) {
                customerIdentifier['google_push_notification_id'] = firebaseToken;
                properties['google_push_notification_id'] = firebaseToken;
            }
            window.exponea.identify(customerIdentifier, properties);
            if (firebaseToken) {
                window.exponea.track('push_subscription', {
                    action: 'accept',
                    google_push_notification_id: firebaseToken,
                    os: 'android',
                    type: 'mobile',
                });
            }
        }
    }, [email, firebaseToken, isLoggedIn]);

    return null;
}

const mapStateToProps = createStructuredSelector({
    email: getUserEmailSelector,
    isLoggedIn: makeSelectAppLoggedIn(),
});

export default connect(mapStateToProps)(ExponeaProvider);
